var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/product-tile-macro.j2"] = require( "macros/product-tile-macro.j2" );
dependencies["contentful/recommendations-container.j2"] = require( "contentful/recommendations-container.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/contentful/product-grid/product-grid-component.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/product-tile-macro.j2", false, "core/templates/contentful/product-grid/product-grid-component.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayProductTile")) {
var t_4 = t_1.displayProductTile;
} else {
cb(new Error("cannot import 'displayProductTile'")); return;
}
context.setVariable("displayProductTile", t_4);
var t_5;
t_5 = (lineno = 2, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.tray"]));
frame.set("tray", t_5, true);
if(frame.topLevel) {
context.setVariable("tray", t_5);
}
if(frame.topLevel) {
context.addExport("tray", t_5);
}
output += "\n";
var t_6;
t_6 = (lineno = 3, colno = 27, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.source"]));
frame.set("source", t_6, true);
if(frame.topLevel) {
context.setVariable("source", t_6);
}
if(frame.topLevel) {
context.addExport("source", t_6);
}
output += "\n";
var t_7;
t_7 = (lineno = 4, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.value"]));
frame.set("value", t_7, true);
if(frame.topLevel) {
context.setVariable("value", t_7);
}
if(frame.topLevel) {
context.addExport("value", t_7);
}
output += "\n";
var t_8;
t_8 = (lineno = 5, colno = 30, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.pageSize"]));
frame.set("tileCount", t_8, true);
if(frame.topLevel) {
context.setVariable("tileCount", t_8);
}
if(frame.topLevel) {
context.addExport("tileCount", t_8);
}
output += "\n";
var t_9;
t_9 = (lineno = 6, colno = 33, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.productTileType","NO_DETAILS"]));
frame.set("tileTemplate", t_9, true);
if(frame.topLevel) {
context.setVariable("tileTemplate", t_9);
}
if(frame.topLevel) {
context.addExport("tileTemplate", t_9);
}
output += "\n";
var t_10;
t_10 = "--" + "" + env.getFilter("replace").call(context, runtime.contextOrFrameLookup(context, frame, "displayType")," ","-");
frame.set("displayTypeClass", t_10, true);
if(frame.topLevel) {
context.setVariable("displayTypeClass", t_10);
}
if(frame.topLevel) {
context.addExport("displayTypeClass", t_10);
}
output += "\n";
if(runtime.contextOrFrameLookup(context, frame, "source") == "Dynamic Yield") {
output += "\n\n    ";
env.getTemplate("contentful/recommendations-container.j2", false, "core/templates/contentful/product-grid/product-grid-component.j2", null, function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
t_11.render(context.getVariables(), frame, function(t_14,t_12) {
if(t_14) { cb(t_14); return; }
output += t_12
output += "\n\n";
})});
}
else {
output += "\n\n    <div\n        class=\"o-row o-column o-extra-small--12 s-contentful-product-grid s-contentful-product-grid";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "displayTypeClass"), env.opts.autoescape);
output += " dom-product-tray-content\"\n        data-index=";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "moduleIndex"), env.opts.autoescape);
output += "\n        data-qa-product-source=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "source"), env.opts.autoescape);
output += "\">\n\n        ";
frame = frame.push();
var t_17 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tray")),"records");
if(t_17) {var t_16 = t_17.length;
for(var t_15=0; t_15 < t_17.length; t_15++) {
var t_18 = t_17[t_15];
frame.set("record", t_18);
frame.set("loop.index", t_15 + 1);
frame.set("loop.index0", t_15);
frame.set("loop.revindex", t_16 - t_15);
frame.set("loop.revindex0", t_16 - t_15 - 1);
frame.set("loop.first", t_15 === 0);
frame.set("loop.last", t_15 === t_16 - 1);
frame.set("loop.length", t_16);
output += "\n\n            ";
output += runtime.suppressValue((lineno = 21, colno = 31, runtime.callWrap(t_4, "displayProductTile", context, [runtime.memberLookup((runtime.memberLookup((t_18),"allMeta")),"tile"),runtime.makeKeywordArgs({"tileTemplate": runtime.contextOrFrameLookup(context, frame, "tileTemplate"),"productIndex": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"),"lazy": runtime.contextOrFrameLookup(context, frame, "isLazy")})])), env.opts.autoescape);
;
}
}
frame = frame.pop();
output += "</div>\n\n";
;
}
output += "\n\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/contentful/product-grid/product-grid-component.j2"] , dependencies)